/** Construit une query string à partir d'un objet params (ignore undefined/null/'') */
export function buildQuery(params?: Record<string, unknown>): string {
  if (!params) return "";
  const qs = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== null && value !== "") {
      qs.set(key, String(value));
    }
  }
  const str = qs.toString();
  return str ? `?${str}` : "";
}
export const uiTokenName = "BoulesConnectTK";
export const reqHeaderTokenBearer = {
  Authorization: `Bearer ${localStorage.getItem(uiTokenName)}`,
};
export const reqHeaderContentTypeJson = {
  "Content-Type": "application/json",
};
